// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReturnFundsAfterCipAccountClosureTypePropertyDto
 */
export interface IReturnFundsAfterCipAccountClosureTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IReturnFundsAfterCipAccountClosureTypePropertyDto
     */
    return_funds_after_cip_account_closure_type?: IReturnFundsAfterCipAccountClosureTypePropertyDtoReturnFundsAfterCipAccountClosureTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReturnFundsAfterCipAccountClosureTypePropertyDto
     */
    return_funds_after_cip_account_closure_type_state?: IReturnFundsAfterCipAccountClosureTypePropertyDtoReturnFundsAfterCipAccountClosureTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IReturnFundsAfterCipAccountClosureTypePropertyDtoReturnFundsAfterCipAccountClosureTypeEnum {
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYER = 'EMPLOYER'
}
/**
* @export
* @enum {string}
*/
export enum IReturnFundsAfterCipAccountClosureTypePropertyDtoReturnFundsAfterCipAccountClosureTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IReturnFundsAfterCipAccountClosureTypePropertyDto interface.
 */
export function instanceOfIReturnFundsAfterCipAccountClosureTypePropertyDto(value: object): value is IReturnFundsAfterCipAccountClosureTypePropertyDto {
    return true;
}

export function IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSON(json: any): IReturnFundsAfterCipAccountClosureTypePropertyDto {
    return IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSONTyped(json, false);
}

export function IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnFundsAfterCipAccountClosureTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'return_funds_after_cip_account_closure_type': json['return_funds_after_cip_account_closure_type'] == null ? undefined : json['return_funds_after_cip_account_closure_type'],
        'return_funds_after_cip_account_closure_type_state': json['return_funds_after_cip_account_closure_type_state'] == null ? undefined : json['return_funds_after_cip_account_closure_type_state'],
    };
}

export function IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSON(json: any): IReturnFundsAfterCipAccountClosureTypePropertyDto {
    return IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSONTyped(json, false);
}

export function IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSONTyped(value?: IReturnFundsAfterCipAccountClosureTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'return_funds_after_cip_account_closure_type': value['return_funds_after_cip_account_closure_type'],
        'return_funds_after_cip_account_closure_type_state': value['return_funds_after_cip_account_closure_type_state'],
    };
}

